import { render } from "./MenuContent.vue?vue&type=template&id=2b87d70a&scoped=true&ts=true"
import script from "./MenuContent.vue?vue&type=script&lang=ts"
export * from "./MenuContent.vue?vue&type=script&lang=ts"

import "./MenuContent.vue?vue&type=style&index=0&id=2b87d70a&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b87d70a"]])

export default __exports__